import React from 'react';
import colours from 'styles/colours';

export default function Icon({type, size, width, height}) {

    const iconTextMap = {
        success: '✓',
        error: '!',
        warning: '!',
        default: 'i'
    };

    type = iconTextMap[type] ? type : 'info';

    const iconColour = colours.icon[type] || colours.icon.default

    const iconTextColour = colours.font.messageIcon[type] || colours.font.messageIcon.default
    const iconText = iconTextMap[type] || iconTextMap.default;

    const iconStyles = {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: width || (size * 2),
        height: height || (size * 2),
        clipPath: 'circle(' + size + 'px)',
        backgroundColor: iconColour,
        color: iconTextColour,
        marginRight: size,
        marginTop: -2
    }

    return <div style={iconStyles} role="img" aria-label={type}>{iconText}</div>

}